/**
 * Calculates an index from a string by summing ASCII codes of first 10 characters
 * and taking modulo with maxLength
 * @param str - The input string
 * @param maxLength - The maximum length to modulo the sum with
 * @returns The calculated index (0 to maxLength-1)
 */
export const getStringsIndex = (str: string, maxLength: number): number => {
	if (!str || maxLength <= 0) {
		return 0;
	}

	const firstTenChars = str.slice(0, 10);
	const asciiSum = firstTenChars.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0);

	return asciiSum % maxLength;
};

export function formatFileSize(bytes: number): string {
	const KB = 1024;
	const MB = KB * 1024;
	const GB = MB * 1024;

	if (bytes < MB) {
		return `${(bytes / KB).toFixed(2)} KB`;
	} else if (bytes < GB) {
		return `${(bytes / MB).toFixed(2)} MB`;
	} else {
		return `${(bytes / GB).toFixed(2)} GB`;
	}
}

// Regex pattern: only allows alphanumeric, space, hyphen, underscore, period, ampersand
const WORKSPACE_NAME_REGEX = /^[a-zA-Z0-9\s\-_.&]*$/;

export const isValidWorkspaceName = (str: string): boolean => {
	if (!str) return false;
	return WORKSPACE_NAME_REGEX.test(str);
};

/**
 * Removes special characters from a string, keeping only allowed characters for workspace names
 * Allowed: alphanumeric (a-z, A-Z, 0-9), spaces, hyphens (-), underscores (_), periods (.), ampersands (&)
 * @param str - The input string to sanitize
 * @returns The sanitized string with only allowed characters
 */
export const sanitizeWorkspaceName = (str: string): string => {
	if (!str) return '';
	return str.replace(/[^a-zA-Z0-9\s\-_.&]/g, '');
};
